import { AuthClientInitOptions } from '@react-keycloak/core/lib/types';
import Keycloak from 'keycloak-js';

// eslint-disable-next-line
export const keycloak = new (Keycloak as any)({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  bearerExcludedUrls: ['/reset-password']
});

export const keycloakProviderInitConfig: AuthClientInitOptions = {
  onLoad: 'login-required',
  silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  pkceMethod: 'S256'
};
